import React, { createContext, useContext, useState } from "react";

const NomenclatureModalContext = createContext();

export const useNomenclatureModal = () => {
  const context = useContext(NomenclatureModalContext);
  if (!context) {
    throw new Error("useNomenclatureModal must be used within NomenclatureModalProvider");
  }
  return context;
};

export const NomenclatureModalProvider = ({ children }) => {
  const [openModal, setOpenModal] = useState(false);
  const [nomenclatureId, setNomenclatureId] = useState(null);

  const openNomenclatureModal = (id) => {
    setNomenclatureId(id);
    setOpenModal(true);
  };

  const closeNomenclatureModal = () => {
    setOpenModal(false);
    setNomenclatureId(null);
  };

  return (
    <NomenclatureModalContext.Provider
      value={{
        openModal,
        nomenclatureId,
        openNomenclatureModal,
        closeNomenclatureModal,
      }}
    >
      {children}
    </NomenclatureModalContext.Provider>
  );
};
